import CTNButton from '@ctn/ui/components/ctn-button';
import CTNMessage from '@ctn/ui/components/ctn-message';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import DocumentosListado from '@/components/DocumentosListado';
import TextIcon from '@/components/TextIcon';
import { useSolicitudContext } from '@/context/solicitud.context';

import { MESSAGE_PREVIEW_FILE } from '@/constants/file.constants';
import { STEP_ID } from '@/constants/tramite.constants';
import { flattenGroupDocumentos } from '@/helpers/formSolicitudes';
import { type FormValues } from '@/interfaces/model/don.interface';



const ResumenStep1 = () => {
	const { id } = useParams();
	const { watch } = useFormContext<Partial<FormValues>>();
	const { setActiveStep } = useSolicitudContext();
	const { requerirDocumentacion } = useSolicitudContext();

	const documentosRequeridos = watch('documentosRequeridos') ?? [];
	const documentosAdicionales = watch('documentosAdicionales') ?? [];

	return (
		<>
			<section >
				<header className="o-splitter">
					<TextIcon
						className="c-pnp-heading-h4"
						tag="h4"
						description="Documentación requerida"
						iconRight={{
							icon: 'info',
							color: 'blue-50',
							tooltip: { content: MESSAGE_PREVIEW_FILE, maxWidth: 432, place: 'top' },
						}}
					/>
					<CTNButton
						mode="secondary"
						label="Modificar"
						variant="ghost"
						size="size-40"
						onClick={() => setActiveStep(STEP_ID.DOCUMENTACION)}
					/>
				</header>
				{!requerirDocumentacion && (
					<CTNMessage
						content={
							<div>
								<p>A continuación te mostramos la documentación requerida para esta escritura. Si no dispones de la documentación en este momento, podrás enviar la solicitud sin necesidad de adjuntarla.</p>
							</div>
						}
						icon="info"
						status="info"
						className='[ u-mt-16 ]'
						mode="outline"
						closable={false}
					/>
				)}
				<div className="u-mt-24 u-mt-16@portrait">
					<DocumentosListado
						documentos={flattenGroupDocumentos(documentosRequeridos)}
						idSolicitud={Number(id as string)}
					/>
				</div>
			</section>
			<section className="u-mt-32">
				<header className="o-splitter">
					<TextIcon
						className="c-pnp-heading-h4"
						tag="h4"
						description="Documentación adicional"
						iconRight={{
							icon: 'info',
							color: 'blue-50',
							tooltip: { content: MESSAGE_PREVIEW_FILE, maxWidth: 432, place: 'top' },
						}}
					/>
					<CTNButton
						mode="secondary"
						label="Modificar"
						variant="ghost"
						size="size-40"
						onClick={() => setActiveStep(STEP_ID.DOCUMENTACION)}
					/>
				</header>
				<div className="u-mt-24 u-mt-16@portrait">
					<DocumentosListado
						documentos={documentosAdicionales}
						idSolicitud={Number(id as string)}
						noData="Aún no has añadido ningún documento adicional"
					/>
				</div>
			</section>
		</>
	);
};

export default ResumenStep1;
